import { render, staticRenderFns } from "./DocumentTemplateFormComponent.vue?vue&type=template&id=33a9024a"
import script from "./DocumentTemplateFormComponent.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateFormComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateFormComponent.vue?vue&type=style&index=0&id=33a9024a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports